import axios from 'axios'
import { format, getMonth, getYear, isAfter, isBefore, subMonths } from 'date-fns'
import React from 'react'
import { baseUrl } from '../../assets/Animations'
import ChurnChart from './ChurnChart/ChurnChart'
import './marketing-stats.css'
import TeacherStatChart from './TeacherStatCharts/TeacherStatCharts'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const MarketingStats = () => {
    const [timesheets, setTimesheets] = React.useState([])
    const [databaseFamilies, setDatabaseFamilies] = React.useState([])
    const [teachers, setTeachers] = React.useState([])
    const [totalAcquistions, setTotalAcquisitions] = React.useState(0)
    const [totalNewStudentFormsSubmitted, setTotalNewStudentFormsSubmitted] = React.useState(0)
    const [totalStudentsOnboardedSinceJune2021, setTotalStudentsOnboardedSinceJune2021] = React.useState(0)
    const [lessonsPerAcquisition, setLessonsPerAcquisition] = React.useState(0)
    const [revenuePerAcquisition, setRevenuePerAcquisition] = React.useState(0)
    const [profitPerAcquisition, setProfitPerAcquisition] = React.useState(0)
    const [lessonsPerNewStudentForm, setLessonsPerNewStudentForm] = React.useState(0)
    const [revenuePerNewStudentForm, setRevenuePerNewStudentForm] = React.useState(0)
    const [profitPerNewStudentForm, setProfitPerNewStudentForm] = React.useState(0)
    const [yearDataObj, setYearDataObj] = React.useState({})
    const [teachersAverageLessonsPerStudent, setTeachersAverageLessonsPerStudent] = React.useState({})
    const [totalCustomersIn2022, setTotalCustomersIn2022] = React.useState(0)
    const [monthlyConversionRateBySchool, setMonthlyConversionRateBySchool] = React.useState({})
    const [churn, setChurn] = React.useState(10)
    const [conversionRate, setConversionRate] = React.useState(70)
    const [goalEnrollment, setGoalEnrollment] = React.useState(0)
    const [requiredInquiriesToGrow, setRequiredInquiriesToGrow] = React.useState(0)
    const [requiredInquiriesToMaintain, setRequiredInquiriesToMaintain] = React.useState(0)
    const [desiredStudentIncrease, setDesiredStudentIncrease] = React.useState(10)
    const [numberOfMonths, setNumberOfMonths] = React.useState(1)
    const [monthlyAcquirementRequirement, setMonthlyAcquirementRequirement] = React.useState(0)
    const [currentEnrollment, setCurrentEnrollment] = React.useState(0)
    const [dataForChurnGraph, setDataForChurnGraph] = React.useState({})
    const [megaData, setMegaData] = React.useState({})

    React.useEffect(() => {
        axios.get(`${baseUrl}/getalltimesheetsendpoint`)
        .then((res) => setTimesheets(res.data))
        .catch((err) => console.log(err))
        axios.get(`${baseUrl}/school-management`, myHeader)
        .then((res) => setDatabaseFamilies(res.data))
        .catch((err) => console.log(err))
        axios.get(`${baseUrl}/initialadminrequest`, myHeader)
        .then((res) => setTeachers(res.data))
        .catch((err) => console.log(err))
    }, [])

    React.useEffect(() => {
        let requiredOnboardings = currentEnrollment * (churn/100)
        setRequiredInquiriesToMaintain(Math.round(requiredOnboardings / (conversionRate/100)))

        let growthOnboardings = (parseInt(goalEnrollment) + parseInt(desiredStudentIncrease)) * (((churn * numberOfMonths)/100))
        setRequiredInquiriesToGrow(Math.round(growthOnboardings / (conversionRate/100)))
      

        const monthlyChurnRate = churn/100;
        const retentionRate = 1 - monthlyChurnRate;
        const monthlyRetentionFactor = Math.pow(retentionRate, numberOfMonths);
      
        const monthlyInquiries = (goalEnrollment - currentEnrollment * monthlyRetentionFactor) / ((1 - monthlyRetentionFactor) / monthlyChurnRate);
      
        setMonthlyAcquirementRequirement(Math.round(monthlyInquiries));

    }, [churn, conversionRate, goalEnrollment, numberOfMonths])

    React.useEffect(() => {
        //console.log(timesheets)
        timesheets.length > 0 && databaseFamilies.length > 0 && tallyFamiliesOnboardedAfterJune2021()
    },[timesheets, databaseFamilies])

    const tallyFamiliesOnboardedEachMonthOf2022 = () => {
        const tallyObject = {}
        let teacherObject = addEachTeacherToTheObject()
        for(let i = 0; i < 12; i++) {
            tallyObject[i] = {'newStudentForms': 0, 'actuallyReceivedLessons': 0}
            for(let j = 0; j < databaseFamilies.length; j++) {
                if(isAfter(new Date(databaseFamilies[j].onboardDate), new Date(2022, i, 1)) && isBefore(new Date(databaseFamilies[j].onboardDate), new Date(2022, (i + 1), 1))) {
                    checkIfFamilyActuallyTookALessonThatMonth(databaseFamilies[j].familyId) && tallyObject[i].actuallyReceivedLessons++
                    tallyObject[i].newStudentForms++
                }
            }
        }
       // console.log(teacherObject)
        setTeachersAverageLessonsPerStudent(teacherObject)
        findNewStudentFormConversionRatePerMonth()
        setYearDataObj(tallyObject)
        //console.log(tallyObject)
    }


    const findNewStudentFormConversionRatePerMonth = () => {
        const tallyObject = {}
        let teacherObject = addEachTeacherToTheObject()
        for(let i = 0; i < 12; i++) {
            tallyObject[i] = {'MMA': {'newStudentForms': 0, 'actuallyReceivedLessons': 0}, 'LSMA': {'newStudentForms': 0, 'actuallyReceivedLessons': 0}, 'TMA': {'newStudentForms': 0, 'actuallyReceivedLessons': 0}, 'MOR': {'newStudentForms': 0, 'actuallyReceivedLessons': 0}, 'PSMA': {'newStudentForms': 0, 'actuallyReceivedLessons': 0}}
            for(let j = 0; j < databaseFamilies.length; j++) {
                let theSchool = databaseFamilies[j].school
                if(isAfter(new Date(databaseFamilies[j].onboardDate), new Date(2022, i, 1)) && isBefore(new Date(databaseFamilies[j].onboardDate), new Date(2022, (i + 1), 1))) {
                    hasThisFamilyEverTakenALesson(databaseFamilies[j].familyId) && tallyObject[i][theSchool].actuallyReceivedLessons++
                    tallyObject[i][theSchool].newStudentForms++
                }
            }
        }
        console.log('-------------------CONVERSION-RATE-BY-MONTH----------------')
        //console.log(tallyObject)
        setMonthlyConversionRateBySchool(tallyObject)
        console.log('-------------------------------')
    }

    const hasThisFamilyEverTakenALesson = (famId) => {
        let found = false
        for(let i = 0; i < timesheets.length; i++) {
            for(let j = 0; j < timesheets[i].families.length; j++) {
                if(famId === timesheets[i].families[j].id) {
                    found = true
                }
            }
        }
        return found
    }

    const addEachTeacherToTheObject = () => {
        let object = {}
        for(let i = 0; i < timesheets.length; i++) {
            if(timesheets[i].year === 2022) {
                let theTimesheetTeacherName = timesheets[i].teacherName
                let theId = timesheets[i].teacherId
                let monthNumber = timesheets[i].monthNumber
                if(object[theId]) {
                    object[theId] = {...object[theId], [monthNumber]: calculateAverageLessonsPerFamily(timesheets[i].families)}
                } else {
                    object[theId] = {'name': theTimesheetTeacherName, 'teacherId': theId, [monthNumber]: calculateAverageLessonsPerFamily(timesheets[i].families)}
                }
            }
        }
        return object
    }

    const calculateAverageLessonsPerFamily = (families) => {
        let totalLessons = 0
        let totalNumberOfStudents = 0
        let studentRepeatObject = {}
        for(let i = 0; i < families.length; i++) {
            totalLessons = totalLessons + families[i].lessons.length
            for(let j = 0; j < families[i].lessons.length; j++) {
                let studentName = families[i].lessons[j].studentName
                if(studentRepeatObject[studentName]) {

                } else {
                    studentRepeatObject[studentName] = true
                    totalNumberOfStudents = totalNumberOfStudents + 1
                }
            }
        }
        return {'numberOfLessons': totalLessons, 'numberOfStudents': totalNumberOfStudents}
        return Math.floor((totalLessons / totalNumberOfStudents) * 100) / 100
    }

    const checkIfFamilyActuallyTookALessonThatMonth = (famId) => {
        let found = false
        for(let j = 0; j < timesheets.length; j++) {
            for(let i = 0; i < timesheets[j].families.length; i++) {
                if(timesheets[j].families[i].id === famId) {
                    found = true
                }
            }
        }
        return found
    }

    const tallyAllCustomersIn2022 = () => {
        let schoolList = ['mma', 'lsma', 'tma', 'mor']
        let giantObject = {'mma': {'label': [], 'enrollment': [], 'studentsLost': [], 'studentsGained': [], 'churn': []}, 'lsma': {'label': [], 'enrollment': [], 'studentsLost': [], 'studentsGained': [], 'churn': []}, 'tma': {'label': [], 'enrollment': [], 'studentsLost': [], 'studentsGained': [], 'churn': []}, 'mor': {'label': [], 'enrollment': [], 'studentsLost': [], 'studentsGained': [], 'churn': []}}
        for(let i = 0; i < schoolList.length; i++) {
            console.log(`_________________${schoolList[i].toUpperCase()}____________________`)
            for(let j = 1; j < 13; j++) {
                let currentMonth = `${format(subMonths(new Date(), j), 'MMMM')}/${format(subMonths(new Date(), j), 'yyyy')}`
                let nextMonth = `${format(subMonths(new Date(), j + 1), 'MMMM')}/${format(subMonths(new Date(), j + 1), 'yyyy')}`
                let firstMonthTracking = {}
                let secondMonthTracking = {}
                let firstMonthTotalCustomers = 0
                let secondMonthTotalCustomers = 0
                let totalChurn = 0

                for(let k = 0; k < timesheets.length; k++) {
                    if(timesheets[k].school === schoolList[i]) {
                        if(timesheets[k].monthYear === nextMonth) {
                            for(let l = 0; l < timesheets[k].families.length; l++) {
                                if(!firstMonthTracking[timesheets[k].families[l].id]) {
                                    firstMonthTracking[timesheets[k].families[l].id] = true
                                    firstMonthTotalCustomers++
                                }
                            }
                        } else if (timesheets[k].monthYear === currentMonth) {
                            for(let n = 0; n < timesheets[k].families.length; n++) {
                                if(!secondMonthTracking[timesheets[k].families[n].id]) {
                                    secondMonthTracking[timesheets[k].families[n].id] = true
                                    secondMonthTotalCustomers++
                                }
                            }
                        }
                    }
        
                }
                //Find every january person who was not billed in february
                Object.keys(firstMonthTracking).map((janTeacherId) => {
                    if(!secondMonthTracking[janTeacherId]) {
                        totalChurn++
                    }
                })
                giantObject[schoolList[i]]['label'].push(nextMonth)
                giantObject[schoolList[i]]['enrollment'].push(firstMonthTotalCustomers)
                giantObject[schoolList[i]]['studentsLost'].push(totalChurn)
                giantObject[schoolList[i]]['studentsGained'].push(((secondMonthTotalCustomers - firstMonthTotalCustomers) + totalChurn))
                giantObject[schoolList[i]]['churn'].push(Math.round((totalChurn / firstMonthTotalCustomers)*100))
                console.log('GIANT')
                console.log(giantObject)
                console.log(`${nextMonth} | ${firstMonthTotalCustomers} | -${totalChurn} | +${(secondMonthTotalCustomers - firstMonthTotalCustomers) + totalChurn} | Churn: ${Math.round((totalChurn / firstMonthTotalCustomers)*100)}%`)
            }
            setDataForChurnGraph(giantObject)
            console.log('                ')
            console.log('                ')
            console.log('                ')
        }

        let totalStudents = 0
        let totalFamilies = 0
        let totalActiveFamilies = 0
        let teacherTallyObj = {}

        for(let i = 0; i < databaseFamilies.length; i++) {
            totalFamilies++
            if(databaseFamilies[i].familyStatus === 'Active') {
                totalActiveFamilies++
            }
            for(let j = 0; j < databaseFamilies[i].students.length; j++) {
                totalStudents++
            }
        }

        //console.log(`TOTAL STUDENTS: ${totalStudents}`)
        //console.log(`TOTAL FAMILIES: ${totalFamilies}`)
        //console.log(totalStudents/totalFamilies)
        //console.log(`TOTAL ACTIVE FAMILIES: ${totalActiveFamilies}`)
        //setTotalCustomersIn2022(totalCustomers)
        findAllTeachersChurn()
    }

    const findAllTeachersChurn = () => {
        let largeObject = {'mma': {}, 'lsma': {}, 'tma': {}, 'mor': {}}
        let listOfSchools = ['mma', 'lsma', 'tma', 'mor']
        for(let i = 0; i < listOfSchools.length; i++) {
            let teacherData = processTeachersForEachSchool(listOfSchools[i])
            largeObject[listOfSchools[i]] = teacherData
        }
        //console.log(largeObject)
        setMegaData(largeObject)
    }

    const processTeachersForEachSchool = (school) => {
        let arrayOfSchoolData = {'labels': [], 'churn': {}, 'roster': {}, 'LPS': {}}
        for(let i = 0; i < teachers.length; i++) {
            let data = []
            if(school === teachers[i].School) {
                data = getTeachersStatsForEachMonth(teachers[i])
                arrayOfSchoolData['labels'] = data[1]
                arrayOfSchoolData['churn'][data[0]] = data[2]
                arrayOfSchoolData['roster'][data[0]] = data[3]
                arrayOfSchoolData['LPS'][data[0]] = data[4]
            }
        }
        return arrayOfSchoolData
    }

    const getTeachersStatsForEachMonth = (teach) => {
        let labels = []
        let teacherChurnPacket = []
        let teacherRosterPacket = []
        let teacherLPSPacket = []
        for(let i = 1; i < 13; i++) {
            let currentMonth = `${format(subMonths(new Date(), i), 'MMMM')}/${format(subMonths(new Date(), i), 'yyyy')}`
            let otherMonth = `${format(subMonths(new Date(), i + 1), 'MMMM')}/${format(subMonths(new Date(), i + 1), 'yyyy')}`
            let firstMonthTracking = {}
            let secondMonthTracking = {}
            let firstMonthTotalStudents = 0
            let secondMonthTotalStudents = 0
            let totalChurn = 0
            let lessonToStudentRatio = []

            for(let k = 0; k < timesheets.length; k++) {
                if(timesheets[k].teacherId === teach.TeacherID) {
                    if(timesheets[k].monthYear === otherMonth) {
                        lessonToStudentRatio = tallyHowManyStudentsAndLessonsWereTaughtPerTimesheet(timesheets[k])
                        for(let l = 0; l < timesheets[k].families.length; l++) {
                            for(let w = 0; w < timesheets[k].families[l].lessons.length; w++)
                            if(!firstMonthTracking[timesheets[k].families[l].lessons[w].studentName]) {
                                firstMonthTracking[timesheets[k].families[l].lessons[w].studentName] = true
                                firstMonthTotalStudents++
                            }
                        }
                    } else if (timesheets[k].monthYear === currentMonth) {
                        for(let n = 0; n < timesheets[k].families.length; n++) {
                            for(let v = 0; v < timesheets[k].families[n].lessons.length; v++)
                            if(!secondMonthTracking[timesheets[k].families[n].lessons[v].studentName]) {
                                secondMonthTracking[timesheets[k].families[n].lessons[v].studentName] = true
                                secondMonthTotalStudents++
                            }
                        }
                    }
                } 
            }
            //Find every january person who was not billed in february
            Object.keys(firstMonthTracking).map((janTeacherId) => {
                if(!secondMonthTracking[janTeacherId]) {
                    totalChurn++
                }
            })
            labels.push(currentMonth)
            teacherChurnPacket.push((Math.round((totalChurn / firstMonthTotalStudents)*100)))
            teacherRosterPacket.push(firstMonthTotalStudents)
            teacherLPSPacket.push((lessonToStudentRatio[0]/lessonToStudentRatio[1]))
            //return [currentMonth, firstMonthTotalStudents, totalChurn, ((secondMonthTotalStudents - firstMonthTotalStudents) + totalChurn), (Math.round((totalChurn / firstMonthTotalStudents)*100)), (lessonToStudentRatio[0]/lessonToStudentRatio[1])]
            //console.log(`${currentMonth} | ${firstMonthTotalStudents} | -${totalChurn} | +${(secondMonthTotalStudents - firstMonthTotalStudents) + totalChurn} | Churn: ${Math.round((totalChurn / firstMonthTotalStudents)*100)}% | ${lessonToStudentRatio[0]/lessonToStudentRatio[1]}`)
        }
        return [teach.Name, labels, teacherChurnPacket, teacherRosterPacket, teacherLPSPacket]
    }

    const tallyHowManyStudentsAndLessonsWereTaughtPerTimesheet = (sheet) => {
        let studentTotal = 0
        let lessonTotal = 0
        let studentKey = {}
        for(let i = 0; i < sheet.families.length; i++) {
            for(let j = 0; j < sheet.families[i].lessons.length; j++) {
                let theStudent = sheet.families[i].lessons[j].studentName
                if(studentKey[theStudent]) {
                    lessonTotal++
                } else {
                    studentKey[theStudent] = true
                    studentTotal++
                    lessonTotal++
                }
            }
        }
        return [lessonTotal, studentTotal]
    }

    const tallyFamiliesOnboardedAfterJune2021 = () => {
        let totalOnboardedFamilies = 0
        let totalNewStudentFormSubmitions = 0
        for(let i = 0; i < databaseFamilies.length; i++) {
            if(isAfter(new Date(databaseFamilies[i].onboardDate), new Date(2021, 5, 1))) {
                //CHECK IF THEY ARE ON A TIMESHEET
                ifFamilyIsNewCountThem(databaseFamilies[i].familyId) && totalOnboardedFamilies++
                totalNewStudentFormSubmitions = totalNewStudentFormSubmitions + 1
            }
        }
        setTotalNewStudentFormsSubmitted(totalNewStudentFormSubmitions)
        setTotalStudentsOnboardedSinceJune2021(totalOnboardedFamilies)
        setTimeout(() => processTimesheets(), 1000)
        tallyFamiliesOnboardedEachMonthOf2022()
        tallyAllCustomersIn2022()
    }

    const ifFamilyIsNewCountThem = (famId) => {
        let found = false
        for(let j = 0; j < timesheets.length; j++) {
            for(let i = 0; i < timesheets[j].families.length; i++) {
                if(timesheets[j].families[i].id === famId) {
                    found = true
                }
            }
        }
        return found
    }

    const processTimesheets = () => {
        let masterObject = {totalLessonsTaught: 0}
        for(let i = 0; i < timesheets.length; i++) {
            tallyFamiliesLessons(timesheets[i].families, masterObject)
        }

        let totalNumberofFamilies = calculateTotalFamiliesThatReceivedLessons(masterObject)
        setTotalAcquisitions(calculateTotalFamiliesThatReceivedLessons(masterObject))
        let averageLessonsPerAcquisition = Math.floor((masterObject['totalLessonsTaught'] / totalNumberofFamilies) * 100) / 100
        let averageLessonsPerNewStudentForm = Math.floor((masterObject['totalLessonsTaught'] / totalNewStudentFormsSubmitted) * 100) / 100
        setLessonsPerAcquisition(Math.floor((masterObject['totalLessonsTaught'] / totalNumberofFamilies) * 100) / 100)

        setLessonsPerNewStudentForm(Math.floor((masterObject['totalLessonsTaught'] / totalNewStudentFormsSubmitted) * 100) / 100)
        let averageLessonLength = 33.72
        let averageMinuteRateForLessons = 78.33 / 60
        let averageMinuteProfitForLessons = (78.33 - 40) / 60

        setRevenuePerAcquisition(Math.floor((((averageLessonsPerAcquisition * averageLessonLength) * averageMinuteRateForLessons) * 100) /100))
        setRevenuePerNewStudentForm(Math.floor((((averageLessonsPerNewStudentForm * averageLessonLength) * averageMinuteRateForLessons) * 100) /100))
        setProfitPerAcquisition(Math.floor((((averageLessonsPerAcquisition * averageLessonLength) * averageMinuteProfitForLessons) * 100) /100))
        setProfitPerNewStudentForm(Math.floor((((averageLessonsPerNewStudentForm * averageLessonLength) * averageMinuteProfitForLessons) * 100) /100))
        let averageRevenuePerAcquisition = (averageLessonsPerAcquisition * averageLessonLength) * averageMinuteRateForLessons
        //console.log(averageRevenuePerAcquisition)
    }

    const tallyFamiliesLessons = (families, key) => {
        for(let i = 0; i < families.length; i++) {
            if(key[families[i].id]) {
                pushEachLesson(families[i].lessons, key[families[i].id], key)
            } else {
                key[families[i].id] = []
                pushEachLesson(families[i].lessons, key[families[i].id], key)

            }
        }
    }

    const pushEachLesson = (lessons, arr, masterObject) => {
        for(let i = 0; i < lessons.length; i++) {
            arr.push(lessons[i])
            masterObject['totalLessonsTaught'] = masterObject['totalLessonsTaught'] + 1
        }
    }

    const calculateTotalFamiliesThatReceivedLessons = (familiesObj) => {
        let totalNumberOfFamilies = 0
        Object.keys(familiesObj).map((famIdKey) => {
            famIdKey !== 'totalLessonsTaught' && familiesObj[famIdKey].length > 0 && totalNumberOfFamilies++
        })
        return totalNumberOfFamilies
    }

    return(
        <div>
            <ChurnChart dataForChurnGraph={dataForChurnGraph} />
            {/* {megaData['mma'] && <TeacherStatChart megaData={megaData} />} */}
            {/* <div className='calculator-section'>
                <div>{requiredInquiriesToGrow} Inquiries to Grow to {parseInt(desiredStudentIncrease) + parseInt(goalEnrollment)} over {numberOfMonths} months</div>
                <div>To Not Shrink We Need {requiredInquiriesToMaintain} Inquiries this month</div>
                <div>To Reach Our Goal We Need {Math.round(monthlyAcquirementRequirement/(conversionRate/100))} Inquiries this month</div>
                <div className='goal-statement'>We have to onboard {monthlyAcquirementRequirement} families per month for the next {numberOfMonths} months to reach our goal of {Math.round(goalEnrollment*1.333)} students</div>
                <div>Current Family Enrollment</div>
                <input value={currentEnrollment} onChange={(e) => setCurrentEnrollment(e.target.value)} />
                <div>Churn</div>
                <input value={churn} onChange={(e) => setChurn(e.target.value)} />
                <div>Conversion Rate %</div>
                <input value={conversionRate} onChange={(e) => setConversionRate(e.target.value)} />
                <div>Goal Family Enrollment</div>
                <input value={goalEnrollment} onChange={(e) => setGoalEnrollment(e.target.value)} />
                <div>Desired Increase</div>
                <input value={desiredStudentIncrease} onChange={(e) => setDesiredStudentIncrease(e.target.value) } />
                <div>Time Period</div>
                <input value={numberOfMonths} onChange={(e) => setNumberOfMonths(e.target.value) } />
            </div> */}
            {/* <div>Total New Student Forms Submitted: {totalNewStudentFormsSubmitted}</div>
            <div>Total Families Actually Taught: {totalStudentsOnboardedSinceJune2021}</div>
            <div>Acquisition Rate Since June 2021: {Math.floor((totalStudentsOnboardedSinceJune2021 / totalNewStudentFormsSubmitted) * 100)/100}</div>
            <div>Lessons per New Student Form: {lessonsPerNewStudentForm}</div>
            <div>Revenue per New Student Form: ${revenuePerNewStudentForm}</div>
            <div>Profit per New Student Form: ${profitPerNewStudentForm}</div>
            <div>------------------------------------------</div>
            <div>Total # of Families: {totalAcquistions}</div>
            <div>Lessons per Family: {lessonsPerAcquisition}</div>
            <div>Revenue per Family: ${revenuePerAcquisition}</div>
            <div>Profit per Family: ${profitPerAcquisition}</div> */}
            {/* <div>
                <div>2022 Conversions</div>
                {Object.keys(yearDataObj).map((num) => (
                    <div className='twenty-conversion__column'>
                        <div className='twenty-conversion__column__month'>{format(new Date(2022,num, 1), 'MMM')}</div>
                        <div className='twenty-conversion__column__total'>{yearDataObj[num].newStudentForms}</div>
                        <div className='twenty-conversion__column__conv'>{yearDataObj[num].actuallyReceivedLessons}</div>
                        <div className='twenty-conversion__column__conv'>{Math.floor((yearDataObj[num].actuallyReceivedLessons / yearDataObj[num].newStudentForms) * 100)}%</div>
                    </div>
                ))}
                <div className='monthly-conversion'>
                    {Object.keys(monthlyConversionRateBySchool).map((month) => (
                        <div className='monthly-conversion__by-school'>
                            <div className='twenty-conversion__column__month'>{format(new Date(2022,month, 1), 'MMM')}</div>
                            {Object.keys(monthlyConversionRateBySchool[month]).map((school) => (
                                <div className='monthly-conversion__each-month-school'>
                                    <div>{school}</div>
                                    <div className='monthly-conversion-in-out__percentage'>{Math.round((monthlyConversionRateBySchool[month][school].actuallyReceivedLessons / monthlyConversionRateBySchool[month][school].newStudentForms) * 100)}%</div>
                                    <div className='monthly-conversion-in-out'>{monthlyConversionRateBySchool[month][school].newStudentForms}</div>
                                    <div className='monthly-conversion-in-out'>{monthlyConversionRateBySchool[month][school].actuallyReceivedLessons}</div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
                <div>Teacher List</div>
                {Object.keys(teachersAverageLessonsPerStudent).map((teacherId) => (
                    <div className='twenty-conversion__each-teacher'>
                        <div>{teachersAverageLessonsPerStudent[teacherId].name}</div>
                        {Object.keys(yearDataObj).map((num) => (
                            <div className='twenty-conversion__each-month'>
                                <div>{format(new Date(2022,num, 1), 'MMM')}</div>
                                {teachersAverageLessonsPerStudent[teacherId][num] ? <div>{teachersAverageLessonsPerStudent[teacherId][num].numberOfLessons} / {teachersAverageLessonsPerStudent[teacherId][num].numberOfStudents}</div> : <div>.</div>}
                            </div>
                        ))}
                    </div>
                ))}
            </div> */}
        </div>
    )
}
export default MarketingStats